import { render, staticRenderFns } from "./swiperEdit.vue?vue&type=template&id=208eda96&scoped=true"
import script from "./swiperEdit.vue?vue&type=script&lang=js"
export * from "./swiperEdit.vue?vue&type=script&lang=js"
import style0 from "./swiperEdit.vue?vue&type=style&index=0&id=208eda96&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208eda96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208eda96')) {
      api.createRecord('208eda96', component.options)
    } else {
      api.reload('208eda96', component.options)
    }
    module.hot.accept("./swiperEdit.vue?vue&type=template&id=208eda96&scoped=true", function () {
      api.rerender('208eda96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/swiperSchool/swiperEdit.vue"
export default component.exports